import React from "react";
import "./ProjectCard.css";
import { Fade } from "react-reveal";
const ProjectCard = ({ repo, theme }) => {
  return (
   
   <Fade bottom duration={2000} distance="40px">
   <div className="project-card" style={{ backgroundColor: theme.background }}>
      <img src={repo.imagen} alt={repo.titulo} className="project-card-image" />
      <div className="project-card-content">
        <h2 >{repo.titulo}</h2>
        <p style={{ color: theme.text }}>{repo.descripcion}</p>
        {repo.enlace && (
          <a href={repo.enlace} target="_blank" rel="noopener noreferrer" style={{ color: theme.link }}>
            Ver Proyecto
          </a>
        )}
      </div>
    </div>
    </Fade>
  );
};

export default ProjectCard;
